import { getIcon, getImage } from "@/constants";
import { MagicWandIcon } from "@radix-ui/react-icons";
import React from "react";
import { useTranslation } from "react-i18next";
import { ReactSVG } from "react-svg";
import { Card } from "../shadcn/ui/card";
import { Crosshair, GraduationCap } from "lucide-react";

const EducationalPlatform: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="bg-white py-12 sm:py-8 rounded-3xl">
            <div className="container mx-auto px-8">
                <div className="flex flex-1 flex-col justify-center items-center gap-y-2">
                    <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl capitalize">
                        {t("about_strive")}
                    </h2>
                    <ReactSVG
                        src={getIcon("title_arrow.svg")}
                        className="relative w-20 text-orange-700 ltr:rotate-180"
                    />
                    {/* <p className="text-md leading-8 text-balance text-gray-400 text-center">
                        {t("about_strive_description")}
                    </p> */}
                </div>
                {/* Main Content Section */}
                <div className="grid lg:grid-cols-2 gap-4 items-start my-4">
                    {/* Right Side - Classroom Image */}
                    <div className="relative col-span-full">
                        <Card className="overflow-hidden shadow-lg rounded-3xl">
                            <img
                                src={getImage("graph.jpeg")}
                                alt={t("interactive_classroom")}
                                className="w-full h-[200] object-contain"
                            />
                        </Card>
                    </div>
                </div>

                {/* Three Features Section */}
                <div className="grid md:grid-cols-2 gap-4">
                    <div className="space-y-4 border border-gray-300 rounded-2xl p-4 w-auto md:w-full">
                        <div className="flex flex-col justify-start items-start gap-4">
                            <div className="w-12 h-12 bg-teal-50 rounded-full flex items-center justify-center">
                                <Crosshair className="text-teal-800" />
                            </div>
                            <h2 className="text-md font-bold text-gray-800">
                                {t("strive_mission")}
                            </h2>
                        </div>
                        <p className="text-gray-500 leading-loose text-sm whitespace-pre-line">
                            {t("strive_mission_description")}
                        </p>
                    </div>
                    <div className="space-y-4 border border-gray-300 rounded-2xl p-4 w-auto md:w-full">
                        <div className="flex flex-col justify-start items-start gap-4">
                            <div className="w-12 h-12 bg-teal-50 rounded-full flex items-center justify-center">
                                <GraduationCap className="text-teal-800" />
                            </div>
                            <h2 className="text-md font-bold text-gray-800">
                                {t("continuous_support")}
                            </h2>
                        </div>
                        <p className="text-gray-500 leading-loose text-sm whitespace-pre-line">
                            {t("student_progress_tracking")}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EducationalPlatform;
